import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import { Redirect, Route, Switch,  Link} from 'react-router-dom';
import Header from './Header';
import SelectLeave from './Leave/SelectLeave';

import SpecifyDays from './Leave/SpecifyDays';
import DownloadForm from './Leave/DownloadForm';



class LeaveApplication extends Component {
    constructor(props)
    {
        super(props);

        this.fetchLeavesAvailable = this.fetchLeavesAvailable.bind(this);
        this.updateSelectedLeave = this.updateSelectedLeave.bind(this);
        this.updateLeaveDetails= this.updateLeaveDetails.bind(this);
        this.nullifySelectedLeave = this.nullifySelectedLeave.bind(this);
      ;


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
    
            startDate:"",
            returnDate:"",
            daysRequested : 0,
            
            selectedLeave:null,
            leavesAvailable: [
                            {"id":1,"title":"Annual Leave", "days":30, "fixed":false, "processing_days":14},
                            {"id":2,"title":"Paternity Leave", "fixed":true, "days":14,"processing_days":10},
                            {"id":3,"title":"Compassionate Leave", "fixed":false,"days":120,"processing_days":14}

            ],
            freeDays:['2019-04-05', '2019-04-07', '2019-04-14', '2019-04-21', '2019-04-28', '2019-06-04',],


            apiError: false, //remember to change to true
            apiResponse:"",


            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            server_changes_made:false

        }
    }


    updateSelectedLeave(leave)
      {

        if(leave)
        {
          if(leave.fixed)
          {
            this.setState({selectedLeave:leave,  daysRequested:leave.days});
          }
          else
          {
            this.setState({selectedLeave:leave, daysRequested:0});
          }
          
        }
       

      }

    nullifySelectedLeave()
    {
      this.setState({selectedLeave:null});
    }

    updateLeaveDetails(startDate, days, returnDate)
    {
      this.setState({startDate:startDate, daysRequested:days, returnDate:returnDate});
    }

  fetchLeavesAvailable()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/staff/getleaves";

            superagent
            .post(url)
            .send({emp_number:_this.props.staff_details.core_details.EmpNo})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                _this.setState({apiError:res.body.error,
                                apiResponse:res.body.message,
                                leavesAvailable: res.body.leaves_available,
                                freeDays: res.body.free_days,
                                loading:false, loaded_successfully:true,server_changes_made:true});

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, apiError:true,loaded_successfully:false, apiResponse:err,server_changes_made:true});
            });

  }

  renderErrorMessage()
  {
    const _this = this;

      if(this.state.apiError && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.apiResponse}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  componentWillMount()
  {
    //this.fetchLeavesAvailable();
  }


  render() {

    const _this=this;
    if(this.state.loading)
    {
        return(
            <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress block-centered" type="bars" color="#000" height="150px" width="200px"  />
                </div>
        );
    }

    return (
      <div className="main-panel">

        <Header title ="Leave Application" />

        <div className="content">
            <div className="container-fluid">



            <div className="row full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content block-centered">
                                    <div className="tab-pane active" id="profile">
                                    
                                      <Switch>

                                        <Route
                                            exact path = "/staff_ui/leave"
                                            render ={(props) => <SelectLeave {...props}

                                                                staff_details = {_this.props.staff_details}
                                                                base_url={_this.props.base_url}
                                                                loginStatus= {this.props.loginStatus}
                                                                leavesAvailable = {this.state.leavesAvailable}
                                                                apiError = {_this.state.apiError}
                                                                apiResponse = {_this.state.apiResponse}
                                                                selectedLeave ={_this.state.selectedLeave}
                                                                updateSelectedLeave = {_this.updateSelectedLeave.bind(_this)}
                                                                updateLeavesAvailable = {_this.fetchLeavesAvailable.bind(_this)}/>}
                                        />

                                        <Route
                                            path = "/staff_ui/leave/selectleave"
                                            render ={(props) => <SelectLeave {...props}

                                                                staff_details = {_this.props.staff_details}
                                                                base_url={_this.props.base_url}
                                                                loginStatus= {this.props.loginStatus}
                                                                leavesAvailable = {this.state.leavesAvailable}
                                                                apiError = {_this.state.apiError}
                                                                apiResponse = {_this.state.apiResponse}
                                                                selectedLeave ={_this.state.selectedLeave}
                                                                updateSelectedLeave = {_this.updateSelectedLeave.bind(_this)}
                                                                updateLeavesAvailable = {_this.fetchLeavesAvailable.bind(_this)}/>}
                                        />

                                          <Route
                                            path = "/staff_ui/leave/specifydays"
                                            render ={(props) => <SpecifyDays {...props}

                                                                staff_details = {_this.props.staff_details}
                                                                base_url={_this.props.base_url}
                                                                loginStatus= {this.props.loginStatus}
                                                                selectedLeave ={_this.state.selectedLeave}
                                                                startDate = {_this.state.startDate}
                                                                returnDate ={_this.state.returnDate}
                                                                daysRequested = {_this.state.daysRequested}
                                                                freeDays = {this.state.freeDays}
                                                                nullifySelectedLeave = {_this.nullifySelectedLeave.bind(_this)}
                                                                updateLeaveDetails = {_this.updateLeaveDetails.bind(_this)}/>}
                                        />
                                        <Route
                                            path = "/staff_ui/leave/downloadform"
                                            render ={(props) => <DownloadForm {...props}

                                                                staff_details = {_this.props.staff_details}
                                                                base_url={_this.props.base_url}
                                                                loginStatus= {this.props.loginStatus}
                                                                leavesAvailable = {this.state.leavesAvailable}
                                                                startDate = {_this.state.startDate}
                                                                returnDate ={_this.state.returnDate}
                                                                daysRequested = {_this.state.daysRequested}
                                                                apiError = {_this.state.apiError}
                                                                apiResponse = {_this.state.apiResponse}
                                                                selectedLeave ={_this.state.selectedLeave}
                                                                nullifySelectedLeave = {_this.nullifySelectedLeave.bind(_this)}
                                                               
                                                                updateSelectedLeave = {_this.updateSelectedLeave.bind(_this)}
                                                                updateLeavesAvailable = {_this.fetchLeavesAvailable.bind(_this)}/>}
                                        />

                                        

                                      </Switch>
                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>

            </div>
            </div>
            </div>





    );
  }
}

export default LeaveApplication;
